import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { CostPlanDetail } from '../types';
import { environment } from '../../../../environments/environment';

const smallTeamConfig = {
    title: 'Small Team',
    persons: '0-10',
    priceLabel: 'Starts from',
    minCost: '$29,240.00',
    introduce: 'Good for teams who just want to maintain existing product.',
    details: [
        { role: 'Business Analyst', count: 1, key: 'Business Analyst' },
        { role: 'Software Engineer', count: 3, key: 'Software Engineer' },
        { role: 'Quality Assurance', count: 1, key: 'Quality Assurance' },
        { role: 'Project Manager', count: 1, key: 'Project Manager' },
    ],
    key: 'small',
};

const largeTeamConfig = {
    title: 'Large Team',
    persons: '10-30',
    priceLabel: 'Price',
    minCost: '$56,970.00',
    introduce: 'Highly recommended for teams who seek to upgrade product.',
    details: [
        { role: 'Business Analyst', count: 1, key: 'Business Analyst' },
        { role: 'Software Engineer', count: 6, key: 'Software Engineer' },
        { role: 'Quality Assurance', count: 2, key: 'Quality Assurance' },
        { role: 'UI/UX Designer', count: 1, key: 'UI/UX Designer' },
        { role: 'Project Manager', count: 1, key: 'Project Manager' },
    ],
    key: 'large',
};

const customizeTeamConfig = {
    title: 'Customize Team',
    persons: 'Unlimited',
    priceLabel: 'Price',
    minCost: 'Customize',
    introduce: 'Customize for teams who want to build a brand-new project.',
    details: [],
    key: 'customize',
};

@Injectable({
    providedIn: 'root',
})
export class CostPlanService {
    constructor(private http: HttpClient) {}

    options = {
        responseType: 'json' as const,
    };

    getDefaultPlans(planType: string): CostPlanDetail {
        switch (planType) {
            case 'small':
                return smallTeamConfig;
            case 'large':
                return largeTeamConfig;
            case 'customize':
                return customizeTeamConfig;
            default:
                return { details: [] };
        }
    }

    getCostPlanConfig(): Observable<any> {
        return forkJoin({
            employeeLocations: this.getEmployeeLocations(),
            employeeTypes: this.getEmployeeTypes(),
            roleLevels: this.getRoleLevels(),
            cweRate: this.getCWERate(),
            roles: this.getRoleList(),
        });
    }

    getEmployeeLocations(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/CostPlan/systemParameters`, this.options);
    }

    getEmployeeTypes(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/CostPlan/employeeTypes`, this.options);
    }

    getCWERate(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/CostPlan/CWERate`, this.options);
    }

    getRoleLevels(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/CostPlan/role/levels`, this.options);
    }

    getRoleList(): Observable<any> {
        return this.http.get(`${environment.apiUrl}/CostPlan/roles`, this.options);
    }

    postRequestQuote(requestBody: Record<string, unknown>): Observable<unknown> {
        return this.http.post(`${environment.apiUrl}/CostPlan/requestQuote`, requestBody);
    }
}
